import React, { useState } from 'react';
import styles from './index.module.scss';

import { If } from 'utils';
import { Table, TableHead, TableRows } from 'components/Tables';
import Loader from './Loader';
import Header from '../Header';
import SyncButton from './SyncButton';
import Rows from './Rows';
import ToggleModal from './ToggleModal';
import CarrierConfig from './CarrierConfig';
import ExternalCarriersBanner from './ExternalCarriersBanner';
import { TABLE_HEADINGS, MODAL_TYPES } from './stubs';

export default function CarriersTable({
  aggregatorId = '',
  carriers = [],
  isFetching = false,
  isDisabled = false,
  allowCarrierSync = false,
  onSynced = () => {},
  onToggle = () => {},
  onUpdate = () => {},
  renderActions = () => null
}) {
  const [modalType, setModalType] = useState(null);
  const [modalData, setModalData] = useState(null);

  const onToggleCarrier = carrier => {
    setModalData(carrier);
    setModalType(MODAL_TYPES.TOGGLE);
  };

  const onEditCarrier = carrier => {
    setModalData(carrier);
    setModalType(MODAL_TYPES.CONFIG);
  };

  return (
    <div className={styles.container}>
      <Header
        title="Available Carriers"
        description={`Control which carriers and services should be used to offer labels for return shipments.`}
      >
        <div className={styles.row}>
          <If test={allowCarrierSync}>
            <SyncButton
              aggregatorId={aggregatorId}
              onSynced={onSynced}
              isDisabled={isFetching || isDisabled}
            />
          </If>
          {renderActions()}
        </div>
      </Header>
      <ExternalCarriersBanner />
      <Table>
        <TableHead headings={TABLE_HEADINGS} />
        <TableRows>
          <Loader isLoading={isFetching}>
            <Rows
              carriers={carriers}
              onEdit={onEditCarrier}
              onToggle={onToggleCarrier}
              isDisabled={isDisabled}
            />
          </Loader>
        </TableRows>
      </Table>
      <CarrierConfig
        isOpen={modalType === MODAL_TYPES.CONFIG}
        carrier={modalData}
        onClose={() => setModalType(null)}
        onClosed={() => setModalData(null)}
        onRefresh={onUpdate}
      />
      <ToggleModal
        aggregatorId={aggregatorId}
        isOpen={modalType === MODAL_TYPES.TOGGLE}
        data={modalData}
        carriers={carriers}
        onClose={() => setModalType(null)}
        onClosed={() => setModalData(null)}
        onRefresh={onToggle}
      />
    </div>
  );
}
